import { ITunnelResultInterface } from '../interfaces/tunnel-result.interface';
import { EmitterTypes } from '../constants/emitter-types.enum';
import { EmitType } from '../constants/emit-types.enum';

export class TunnelResult implements ITunnelResultInterface {
  public emitter: EmitterTypes;
  public responseType: EmitType;
  public payload: any;

  constructor(emitter: EmitterTypes, responseType: EmitType, data: any = null) {
    this.emitter = emitter;
    this.responseType = responseType;
    this.payload = data;
  }

  public setData(payload) {
    this.payload = payload;
  }

  public getData() {
    return this.payload;
  }


}
